import axios, { API_VERSION } from "../config";

export const getSharedWithUsersByEntityId = (entityId, params) =>
  axios.get(`${API_VERSION}/shares/sharedwith/${entityId}`, { params });
